export default __webpack_public_path__ + "static/portfolio-mas-11-786c97a136763ce698a1d0c177746795.jpg";